/**
 * app/(marketing)/legal/privacy.tsx - getabeam.com Privacy Policy (web, public).
 * Content lives in src/marketing/legal.ts; rendering in src/marketing/legalPage.tsx.
 */
import { LegalPage } from '../../../src/marketing/legalPage';
import { legalDocBySlug } from '../../../src/marketing/legal';

export default function PrivacyScreen() {
  return <LegalPage doc={legalDocBySlug('privacy')} />;
}
